<template>
  <figure class="container mx-auto">
    <slot />
  </figure>
</template>
